import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import fetchSimilarVehicles from '../../../services/vehicles/similar';

const getSimilarVehicles = (
  {
    locale,
    vehicle,
  }: {
    locale: string;
    vehicle: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchSimilarVehicles>
] => [
  ['similar-vehicles', { locale, vehicle }],
  ({
    queryKey: [, key],
  }: {
    queryKey: [
      string,
      {
        locale: string;
        vehicle: string;
      }
    ];
  }) => fetchSimilarVehicles(key, req),
];

export default getSimilarVehicles;
